import { useCallback } from 'react'
import { figs } from '../components/ui/fig'
import { usePixelToast } from '../components/ui/pixel-toast'
import soft from '../styles/soft.module.css'
import { useIsGuest } from './AccountSessionContext'
import { useAuthShell } from './AuthShellContext'
import styles from './guestTradePrompt.module.css'

export const GUEST_TRADE_COPY = 'Log in to trade'

export function useGuestTradePrompt() {
  const guest = useIsGuest()
  const { openAuth } = useAuthShell()
  const toast = usePixelToast()
  const prompt = useCallback(() => {
    toast.push({
      tone: 'info',
      duration: 5000,
      // the words beside the toast's mark, cut to their capitals (soft.fig,
      // the operator, 2026-11-03): the mark on the middle of the capitals.
      // The toast's own figs() cuts plain words only, not this pair.
      content: (
        <>
          <span className={`${styles.loginLink} ${soft.fig}`}>Log in</span> {figs('to trade')}
        </>
      ),
      onClick: () => openAuth('chooser'),
    })
  }, [openAuth, toast])
  return { guest, prompt }
}
